class Modal {
	constructor(options = {}) {
		this.modal = document.querySelector(options.modal);
		this.triggers = document.querySelectorAll(options.trigger);

		if (!this.modal || !this.triggers.length) return;

		this.closeBtn = this.modal.querySelector('.modal__close');

		this.init();
	}

	init() {
		this.triggers.forEach(trigger => {
			trigger.addEventListener("click", (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.open();
			});
		});

		if (this.closeBtn) {
			this.closeBtn.addEventListener("click", () => this.close());
		}

		// Close when clicking outside modal content
		this.modal.addEventListener("click", (e) => {
			if (e.target === this.modal) this.close();
		});
	}

	open() {
		this.modal.classList.add("active");
	}

	close() {
		this.modal.classList.remove("active");
	}
}